// @flow
// flowlint unclear-type:off
import { css } from 'styled-components'
import { defaultTheme } from 'themes/default'

const { breakpoints } = defaultTheme

export const breakpoint = Object.keys(breakpoints).reduce((accumulator, label) => {
  accumulator[label] = (...args) => css`
    @media screen and (min-width: ${breakpoints[label]}px) {
      ${css(...args)};
    }
  `

  return accumulator
}, {})

const CONDITIONS = (() => {
  const maxWidth = (point: number) => `(max-width: ${point}px)`
  const minWidth = (point: number) => `(min-width: ${point}px)`

  return {
    MAX: maxWidth,
    MIN: minWidth,
    RANGE: (point1: number, point2: number) => `${minWidth(point1)} and ${maxWidth(point2)}`,
  }
})()

const createMediaQuery = (condition: (...points: number[]) => string, ...points: number[]) => (media?: string) => (
  ...args: any[]
) => css`
  @media screen and ${condition(...points)} ${media !== undefined && typeof media === 'string' ? `and ${media}` : ``} {
    ${css(...args)}
  }
`

/**
 * @return `@media screen and (min-width: 321px) and (max-width: 375px) { ...args }`
 */
export const screenXs = createMediaQuery(CONDITIONS.RANGE, breakpoints.xxs, breakpoints.xs + 1)

/**
 * @return `@media screen and (min-width: 376px) and (max-width: 768px) { ...args }`
 */
export const screenS = createMediaQuery(CONDITIONS.RANGE, breakpoints.xs, breakpoints.s + 1)

/**
 * @return `@media screen and (min-width: 769) and (max-width: 1024px) { ...args }`
 */
export const screenM = createMediaQuery(CONDITIONS.RANGE, breakpoints.s, breakpoints.m + 1)

/**
 * @return `@media screen and (min-width: 1025px) and (max-width: 1280px) { ...args }`
 */
export const screenL = createMediaQuery(CONDITIONS.RANGE, breakpoints.m, breakpoints.l + 1)

/**
 * @return `@media screen and (min-width: 1281px) and (max-width: 1440px) { ...args }`
 */
export const screenXl = createMediaQuery(CONDITIONS.RANGE, breakpoints.l, breakpoints.xl + 1)

/**
 * @return `@media screen and (max-width: 319px) { ...args }`
 */
export const screenMaxXxs = createMediaQuery(CONDITIONS.MAX, breakpoints.xxs)

/**
 * @return `@media screen and (max-width: 374px) { ...args }`
 */
export const screenMaxXs = createMediaQuery(CONDITIONS.MAX, breakpoints.xs)

/**
 * @return `@media screen and (min-width: 375px) { ...args }`
 */
export const screenMinXs = createMediaQuery(CONDITIONS.MIN, breakpoints.xs + 1)

/**
 * @return `@media screen and (max-width: 767px) { ...args }`
 */
export const screenMaxS = createMediaQuery(CONDITIONS.MAX, breakpoints.s)

/**
 * @return `@media screen and (min-width: 768px) { ...args }`
 */
export const screenMinS = createMediaQuery(CONDITIONS.MIN, breakpoints.s + 1)

/**
 * @return `@media screen and (max-width: 1023px) { ...args }`
 */
export const screenMaxM = createMediaQuery(CONDITIONS.MAX, breakpoints.m)

/**
 * @return `@media screen and (min-width: 1024px) { ...args }`
 */
export const screenMinM = createMediaQuery(CONDITIONS.MIN, breakpoints.m + 1)

/**
 * @return `@media screen and (max-width: 1279px) { ...args }`
 */
export const screenMaxL = createMediaQuery(CONDITIONS.MAX, breakpoints.l)

/**
 * @return `@media screen and (min-width: 1280px) { ...args }`
 */
export const screenMinL = createMediaQuery(CONDITIONS.MIN, breakpoints.l + 1)

/**
 * @return `@media screen and (max-width: 1439px) { ...args }`
 */
export const screenMaxXl = createMediaQuery(CONDITIONS.MAX, breakpoints.xl)

/**
 * @return `@media screen and (min-width: 1440px) { ...args }`
 */
export const screenMinXl = createMediaQuery(CONDITIONS.MIN, breakpoints.xl + 1)
